import React, { useEffect, useState } from 'react';
import './Products.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import Product from '../Components/Product/Product';
import Cart from '../Cart/Cart';
const Products = () => {

    const [products, setProducts] = useState([]);
    const [cart, setCart] = useState([]);
    const [randoms, setRandoms] = useState([]);

    useEffect(() => {

        fetch('data.json')
            .then(Response => Response.json())
            .then(data => setProducts(data))
    }, [products])

    const handleAddToCart = (product) => {
        if (cart.length <= 3) {
            setCart([...cart, product])
        }
    }
    const handleChooseForMe = () => {
        const item = cart[Math.floor(Math.random() * cart.length)]
        setRandoms(item)
    }

    const handleChooseAgain = () => {

        setCart([])
    }



    return (


        <div className="px-4">

            <div className="row">
                <div className="col-9">
                    <div className="row row-cols-md-3 g4">
                        {
                            products.map(product => <Product key={product.id} product={product}
                                handleAddToCart={handleAddToCart}>
                            </Product>)
                        }
                    </div>

                </div>
                <div className="col-md-3 mt-4">
                    <div className="row">
                        <div className="cols-4">
                            {
                                cart.map(cart => <Cart key={cart.id} cart={cart}></Cart>)
                            }
                            <div> <p>{randoms.name}</p>
                                <button className='btn btn-danger m-2' onClick={handleChooseForMe}>CHOOSE FOR ME</button>
                                <button className='btn btn-success' onClick={handleChooseAgain}>CHOOSE AGAIN</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>


    );
};

export default Products;